import { MessageType } from "../enums/traffic-info-enums";
import { MessageInfo } from "./message-info.model";

export class MessageModel {
  constructor(
    public body: string | null = null,
    public createdAt: Date | null = null,
    public heading: string | null = null,
    public id: string | null = null,
    public info: MessageInfo = new MessageInfo(),
    public type: string | null = null,
    public updatedAt: Date | null = null,
    public validFrom: Date | null = null,
    public validTo: Date | null = null,
    public ver: number = 1,
    public timeIntervalEnabled: boolean = false,
    public timeIntervalStart: string = "00:00:00",
    public timeIntervalEnd: string = "23:59:59"
  ) {}
}